import { render, staticRenderFns } from "./Stay.vue?vue&type=template&id=41cc6356&scoped=true&"
import script from "./Stay.vue?vue&type=script&lang=js&"
export * from "./Stay.vue?vue&type=script&lang=js&"
import style0 from "./Stay.vue?vue&type=style&index=0&id=41cc6356&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41cc6356",
  null
  
)

export default component.exports